import { SIGNATURE_MARKER } from "@redotech/email/signature";

// Marker can persist as a raw char or HTML entity depending on the serializer.
const SIGNATURE_MARKER_FORMS = [SIGNATURE_MARKER, "&#x200B;", "&#8203;"];

/** Bake the team email signature into auto-reply html when absent. The support-v2
 * executor sends htmlContent verbatim, so the signature must live in saved content. */
export function buildSeededAutoReplyHtml(
  htmlContent: string,
  signature: string | undefined,
  alreadySeeded?: boolean,
): string {
  if (!signature || alreadySeeded) {
    return htmlContent;
  }
  const hasSignature = SIGNATURE_MARKER_FORMS.some((form) =>
    htmlContent.includes(form),
  );
  return hasSignature
    ? htmlContent
    : `${htmlContent}<br><br><p>&#x200B;--</p>${signature}`;
}
